module.exports = __webpack_public_path__ + "static/media/Icon feather-edit.3cc84f34.svg";